export const dataTypes = {
    STRING:"string",
  };